export const mapOptions = (data: { id; name }[], addAllOption = false) => {
  const mappedData = data
    .map(({ id, name }) => ({ label: name, value: id }))
    .sort((a, b) => {
      const labels = [a.label.toUpperCase(), b.label.toUpperCase()]
      const checkLabels = labels[0] > labels[1] ? 1 : 0
      return labels[0] < labels[1] ? -1 : checkLabels
    })
  return addAllOption ? [{ label: 'MTR_COMMON_ALL', value: null }, ...mappedData] : mappedData
}
